import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { BuyerRefundRequestModal } from 'v2/components/Shared/RefundReason';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

import type { IRefundRequest, IShoppingProduct } from 'v2/interfaces/shopping';

const RefundActions = ({ shopping }: { shopping: IShoppingProduct }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [refundRequest] = useObservable<IRefundRequest>(() => refundRequestFactory.buyerFindRefundByInvoiceId(shopping.invoice_id), []);

  const openRefundRequestModal = () => {
    setOpen(true);
  };

  const closeRefundRequestModal = () => {
    setOpen(false);
  };

  const onRefundRequestMade = () => {
    setOpen(false);
  };

  const canShowRefundRequestButton = refundRequest && !refundRequest.exist && shopping?.product?.valid_to_refund_request;
  if (!canShowRefundRequestButton) return null;

  return (
    <>
      <Grid item xs={12}>
        <Button color='primary' style={{ background: '#dc3f53', color: '#ffffff' }} onClick={openRefundRequestModal} fullWidth>
          Solicitar Reembolso
        </Button>
      </Grid>
      <BuyerRefundRequestModal open={open} invoiceId={shopping.invoice_id} onClose={closeRefundRequestModal} onFinish={onRefundRequestMade} />
    </>
  );
};

export default RefundActions;
